import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { CarouselMutationKeys } from '../../../keys'
import { deleteCarouselItem } from '../../services'

interface UseMutationDeleteCarouselItemProps {
	itemId: string
}

export default function useMutationDeleteCarouselItem(
	props?: UseBaseMutationOptions<void, UseMutationDeleteCarouselItemProps>,
) {
	return useMutation({
		mutationKey: [CarouselMutationKeys.DeleteCarouselItem],
		mutationFn: ({ itemId }) => deleteCarouselItem(itemId),
		...props,
	})
}
